 
import WebOffice from '../../../webOffice/index'; 

export default{
    components: {//自定义组件列表 
        'web-office':WebOffice
	},
    data() {
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name:'签报列表', path:''
            },{
                name:'签报详情', path:''
            }],
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/official/sign/save',//保存
                bykey:'oa/official/sign/byKey',//详情
                getWfTask:'/oa/official/getWFTask',//任务详情
                sign: 'sh/wf/task/sign', //签收任务 
            }, 
            editObj:{
                title:"",
                fileKey:"", 
                isCheck:0,
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"",
            fileList:[],//源文件
            enclosureList:[],//附件 
            userWnd: false,//是否显示人员选择窗口
            rules:{ 
                title:[{ required: true, message: '请输入标题', trigger: 'blur' }], 
            },
            fileNumList:[],
            webShow:false,
            WFtask: {},
            docFileKey: '',
            fileType: ".docx",
            fileLists: [],
            drawer:false,
        }
    },
    props: {
        visible: { 
          type: Boolean,
          default: false
        }, 
        bizKey: String,
        taskKey: String, 
    },
    watch: {
        bizKey() {
            this.init();
        }, 
    }, 
    mounted() {  
        this.init(); 
    },                                         
    methods: { 
        init() {
            this.key = this.bizKey;
            let taskKey = this.taskKey;
            if (this.key > -1) {
                this.find();
            }
            if (taskKey > -1) {
                this.getWfTask(taskKey);
            }
        },
        getWfTask(taskKey){ 
            this.$post({
                url: this.apis.getWfTask,
                params:taskKey,  
            }).then(rsp => {
                if(rsp.success){
                    this.WFtask = rsp.retObj; 
                    if(this.WFtask.type==2){
                        this.sign();
                    }
                }
            })
        },
        sign(){
            const me = this;
            me.$post({
                url: me.apis.sign,
                params: me.WFtask.id
            }).then(rsp => {
                if(rsp.success){ 
                    me.$message.success("签收成功");
                }
            })
        },
        handlePreview(file) {
            if (file.kindType == 1) {
                this.$emit('changeBiz',file.docKey,1); 
            } else if (file.kindType == 2) {
                this.$emit('changeBiz',file.docKey,2);
            } else if (file.kindType == 3) {
                this.$emit('changeBiz',file.docKey,3);
            } else if (file.kindType == 4) {
                this.$emit('changeBiz',file.docKey,4);
            } else {
                if (file.filePath.includes(".docx") || file.filePath.includes(".xlsx") || file.filePath.includes(".doc") || file.filePath.includes(".xls")) {
                    // this.isView = 1;
                    // this.docFileKey = file.fileKey;
                    // this.fileType = file.filePath.substring(file.filePath.lastIndexOf("."), file.filePath.length);
                    // this.webShow = true;
                    let {href}  = this.$router.resolve({ 
                        path: "/oa/office/browerDialog",
                        query:{
                            isView:1,
                            bizKey:this.key,
                            fileType:file.filePath.substring(file.filePath.lastIndexOf("."), file.filePath.length),
                            bizType:4,
                            fileId:file.fileKey 
                        }
                    })    
                    this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
               
                }else if(file.filePath.includes(".txt") ||file.filePath.includes(".pdf") || file.filePath.includes(".PDF") || file.filePath.includes(".png") || file.filePath.includes(".PNG")|| file.filePath.includes(".jgp") || file.filePath.includes(".JPG")|| file.filePath.includes(".gif") || file.filePath.includes(".GIF")){
                    const url = this.$global.baseUrl + file.filePath;
                    window.open(url, '_blank');
                }   
                else {
                    const url = this.$global.baseUrl + 'sh/file/download?id=' + file.fileKey;
                    window.open(url, '_blank');
                }
            } 
        },
        find(){
            const me = this;
            me.key = me.bizKey;
            me.$post({
                url: me.apis.bykey,
                params:me.key,  
            }).then(rsp => {
                if(rsp.success){
                    me.editObj = rsp.retObj;
                    me.fileLists = rsp.retObj.officialFiles;
                    me.$delete(me.editObj, 'officialFiles');
                }
            })
        }, 
        goBack(){ 
            this.$router.go(-1);
        },  
        editDoc() {
            // this.docFileKey = this.editObj.fileKey;
            // this.fileType = ".docx";
            // this.webShow=true;
            let {href}  = this.$router.resolve({ 
                path: "/oa/office/browerDialog",
                query:{
                    isView:1,
                    bizKey:this.key,
                    fileType:".docx",
                    bizType:4,
                    fileId:this.editObj.fileKey 
                }
            })    
            this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
       
        },
        downloadFile(row){
            if(row.fileKey){
                const url = this.$global.baseUrl + 'sh/file/download?id=' + row.fileKey;
                window.open(url, '_blank');
            }else{
                this.$message.error("该公文未编辑文件,请检查!");
                return;
            }
        },
        downloadAll(){
            const url = this.$global.baseUrl +"oa/official/downloadFileAll?bizKey=" + this.key;
            window.open(url, '_blank');
           
        },
        callback(){
            
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/official/signDoc/view/view.js